import React from "react";
import useTranslator from "../../hooks/useTranslator";
import { Select } from "../design";

const AggregationStrategySelector = ({ value = "MIN", onChange }) => {
  const { _t } = useTranslator();

  return (
    <Select
      id="aggregation-strategy"
      size="sm"
      label={_t("aggregationStrategy", "Score aggregation")}
      value={value}
      onChange={(event) => onChange(event.target.value)}
      options={[
        { value: "MIN", label: _t("minimum", "Minimum") },
        { value: "MAX", label: _t("maximum", "Maximum") },
        { value: "MEAN", label: _t("mean", "Mean") },
      ]}
    />
  );
};

export default AggregationStrategySelector;
